module.exports = __webpack_public_path__ + "img/logo1.9b6905ef.png";